'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var PlainTooltip_parts = require('./PlainTooltip.parts.js');

/**
 * 마우스 호버 시 툴팁을 표시하는 컴포넌트입니다.
 *
 * @component
 * @param {Object} props
 * @param {'up' | 'down' | 'left' | 'right'} [props.variant='up'] - 툴팁이 표시될 방향
 * @param {string} [props.text] - 툴팁에 표시될 텍스트
 * @param {ReactNode} [props.children] - 툴팁을 표시할 대상 요소
 * @param {string} [props.className] - 최상위 컨테이너에 적용할 추가 클래스
 * @param {boolean} [props.disabled=false] - 툴팁 비활성화 여부
 * @param {string} [props.tooltipClassName] - 툴팁 컨테이너에 적용할 추가 클래스
 *
 * @example
 * // 기본 사용법
 * <PlainTooltip text="도움말 내용">
 *   <button>마우스를 올려보세요</button>
 * </PlainTooltip>
 *
 * // 방향 지정
 * <PlainTooltip
 *   variant="right"
 *   text="오른쪽에 표시되는 툴팁"
 * >
 *   <span>도움말</span>
 * </PlainTooltip>
 *
 * // 비활성화
 * <PlainTooltip
 *   text="이 툴팁은 표시되지 않습니다"
 *   disabled={true}
 * >
 *   <div>비활성화된 툴팁</div>
 * </PlainTooltip>
 */ const PlainTooltip = ({ variant = 'up', text, children, className, disabled = false, tooltipClassName })=>{
    return jsxRuntime.jsx(Box, {
        "data-testid": "design-system-plain-toolTip",
        className: tailwindMerge.twMerge('inline-block', className),
        children: jsxRuntime.jsxs(Box, {
            "data-testid": "design-system-plain-toolTip--child",
            className: "group relative",
            children: [
                children,
                !disabled && jsxRuntime.jsxs(Box, {
                    className: tailwindMerge.twMerge('pointer-events-none absolute z-10 w-max select-none opacity-0 transition-all duration-500 ease-in-out', 'group-hover:pointer-events-auto group-hover:opacity-100', variant === 'up' && 'bottom-full left-1/2 -translate-x-1/2 group-hover:-translate-y-3', variant === 'down' && 'left-1/2 top-full -translate-x-1/2 group-hover:translate-y-3', variant === 'left' && 'right-full top-1/2 -translate-y-1/2 group-hover:-translate-x-3', variant === 'right' && 'left-full top-1/2 -translate-y-1/2 group-hover:translate-x-3', tooltipClassName),
                    "data-testid": "design-system-plain-toolTip--container",
                    children: [
                        jsxRuntime.jsx(PlainTooltip_parts.Arrow, {
                            testId: "design-system-plain-toolTip--arrow",
                            className: tailwindMerge.twMerge('absolute z-10', variant === 'up' && '-bottom-[7px] left-1/2 -translate-x-1/2 -rotate-90', variant === 'down' && '-top-[7px] left-1/2 -translate-x-1/2 rotate-90', variant === 'left' && '-right-[5px] top-1/2 -translate-y-1/2 rotate-180', variant === 'right' && '-left-[5px] top-1/2 -translate-y-1/2 rotate-0')
                        }),
                        jsxRuntime.jsx(Box, {
                            className: "z-0 flex h-auto min-h-[28px] w-full items-center justify-center rounded-lg bg-w-black px-3 py-1 text-center",
                            children: jsxRuntime.jsx(Typography, {
                                variant: "body3",
                                className: "whitespace-pre text-wrap break-all font-medium text-w-white opacity-100",
                                children: text
                            })
                        })
                    ]
                })
            ]
        })
    });
};

module.exports = PlainTooltip;
